import { Enum, EnumValues } from "./Enum"

export type EnumPropertyMap<T extends Enum, V> = {
    [key in EnumValues<T>]?: V
}

export type EnumPresentMap<T extends Enum> = EnumPropertyMap<T, boolean>

export type SearchableEnumProperties<T extends Enum, V> = {
    map: EnumPropertyMap<T, V>
}

export type SearchableEnumPresent<T extends Enum = Enum> = {
    map: EnumPresentMap<T>
}

export function getEnumPresentValues<T extends Enum = Enum>(map: EnumPresentMap<T>): T[EnumValues<T>][] {
    return Object.keys(map) as T[EnumValues<T>][]
}
